"use client";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { OptionsContext } from "@/provider/options-provider";
import { useContext } from "react";

export function ExtraOptions({
  className,
}: {
  className?: React.ComponentProps<"div">["className"];
}) {
  const { searchOptions, setSearchOptions } = useContext(OptionsContext);
  return (
    <div className={className}>
      <div className="flex flex-col py-2">
        <Label className="mb-1 text-xs">Summarize the first</Label>
        <p className="text-xs text-muted-foreground">
          Displays a summary for the first document hits when searching. Set to
          0 to disable.
        </p>
        <ToggleGroup
          type="single"
          value={searchOptions.maxSummaryItems}
          onValueChange={(v) => {
            setSearchOptions({
              ...searchOptions,
              maxSummaryItems: v,
            });
          }}
          className="justify-start text-xs"
        >
          <ToggleGroupItem
            value="0"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            0
          </ToggleGroupItem>
          <ToggleGroupItem
            value="5"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            5
          </ToggleGroupItem>
          <ToggleGroupItem
            value="10"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            10
          </ToggleGroupItem>
          <ToggleGroupItem
            value="20"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            20
          </ToggleGroupItem>
          <ToggleGroupItem
            value="50"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            50
          </ToggleGroupItem>
          <ToggleGroupItem
            value="100"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            100
          </ToggleGroupItem>
        </ToggleGroup>
      </div>
      <Separator className="my-1" />
      <div className="flex flex-col">
        <Label className="mb-1 text-xs">Sort order</Label>
        <p className="text-xs text-muted-foreground">
          Select the sort order for search results.
        </p>
        <ToggleGroup
          type="single"
          value={searchOptions.order_by}
          onValueChange={(v) => {
            setSearchOptions({
              ...searchOptions,
              order_by: v as "submitDate" | "_score",
            });
          }}
          className="justify-start"
        >
          <ToggleGroupItem
            value="_score"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            Relevance
          </ToggleGroupItem>
          <ToggleGroupItem
            value="submitDate"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            Date
          </ToggleGroupItem>
        </ToggleGroup>
      </div>
      <Separator className="my-1" />
      <div className="flex flex-col">
        <Label className="mb-1 text-xs">
          Max number of documents to search for
        </Label>
        <p className="text-xs text-muted-foreground">
          Maximum number of results expected when searching.
        </p>
        <ToggleGroup
          type="single"
          value={searchOptions.maxSearchResults}
          onValueChange={(v) => {
            setSearchOptions({
              ...searchOptions,
              maxSearchResults: v,
            });
          }}
          className="justify-start"
        >
          <ToggleGroupItem
            value="5"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            5
          </ToggleGroupItem>
          <ToggleGroupItem
            value="10"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            10
          </ToggleGroupItem>
          <ToggleGroupItem
            value="20"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            20
          </ToggleGroupItem>
          <ToggleGroupItem
            value="50"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            50
          </ToggleGroupItem>
          <ToggleGroupItem
            value="75"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            75
          </ToggleGroupItem>
          <ToggleGroupItem
            value="100"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            100
          </ToggleGroupItem>
          <ToggleGroupItem
            value="250"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            250
          </ToggleGroupItem>
        </ToggleGroup>
      </div>
      <Separator className="my-1" />
      <div className="flex flex-col">
        <Label className="mb-1 text-xs">Max fragments</Label>
        <p className="text-xs text-muted-foreground">
          Maximum number of fragments to display in each item.
        </p>
        <ToggleGroup
          type="single"
          value={searchOptions.maxFragments}
          onValueChange={(v) => {
            setSearchOptions({
              ...searchOptions,
              maxFragments: v,
            });
          }}
          className="justify-start"
        >
          <ToggleGroupItem
            value="1"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            1
          </ToggleGroupItem>
          <ToggleGroupItem
            value="2"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            2
          </ToggleGroupItem>
          <ToggleGroupItem
            value="3"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            3
          </ToggleGroupItem>
          <ToggleGroupItem
            value="4"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            4
          </ToggleGroupItem>
          <ToggleGroupItem
            value="5"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            5
          </ToggleGroupItem>
          <ToggleGroupItem
            value="10"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            10
          </ToggleGroupItem>
        </ToggleGroup>
      </div>
      <Separator className="my-1" />
      <div className="flex flex-col">
        <Label className="mb-1 text-xs">Fragment size</Label>
        <p className="text-xs text-muted-foreground">
          The maximum size of each fragment in number of characters.
        </p>
        <ToggleGroup
          type="single"
          value={searchOptions.fragmentSize}
          onValueChange={(v) => {
            setSearchOptions({
              ...searchOptions,
              fragmentSize: v,
            });
          }}
          className="justify-start"
        >
          <ToggleGroupItem
            value="100"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            100
          </ToggleGroupItem>
          <ToggleGroupItem
            value="200"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            200
          </ToggleGroupItem>
          <ToggleGroupItem
            value="500"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            500
          </ToggleGroupItem>
          <ToggleGroupItem
            value="700"
            className="text-xs  data-[state=on]:bg-slate-600 data-[state=on]:text-white"
          >
            700
          </ToggleGroupItem>
        </ToggleGroup>
      </div>
      {/* <Separator className="my-1" />
      <div className="flex items-center space-x-2">
        <Switch
          id="airplane-mode"
          className="scale-75"
          checked={searchOptions.showGroupSummary}
          onCheckedChange={(v) => {
            setSearchOptions({
              ...searchOptions,
              showGroupSummary: v,
            });
          }}
        />
        <Label htmlFor="airplane-mode" className="text-xs">
          Show group summary
          <p className="text-xs text-muted-foreground">
            Company only search will always display a group summary. Use this to
            show group summary for general searches.
          </p>
        </Label>
      </div> */}
    </div>
  );
}
